import React, { useRef } from 'react';
import styled from 'styled-components';
import { Grid, Paper } from '@material-ui/core';
import { useDrag, useDrop, DropTargetMonitor } from 'react-dnd';
import { XYCoord } from 'dnd-core';

import { ItemTypes } from '../../../../../constants';

import DragItem from '../../../shared/DragItem/DragItem';

interface Props {
  title: string;
  index: number;
  id: string;
  moveCard: (dragIndex: number, hoverIndex: number) => void;
  handleDeleteAction: () => void;
  cost: number;
  timings: number;
  isActionDrag: boolean;
  handleOpenWithEdit: () => void;
}

interface DragItem {
  index: number;
  id: string;
  type: string;
}

const AssessmentEditDragItem = (props: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [, drop] = useDrop({
    accept: ItemTypes.EDIT_DRAG,
    hover(item: DragItem, monitor: DropTargetMonitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = props.index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current!.getBoundingClientRect();

      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      const clientOffset = monitor.getClientOffset();

      const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      props.moveCard(dragIndex, hoverIndex);

      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.EDIT_DRAG, id: props.id, index: props.index },
    collect: (monitor: any) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  return (
    <Grid item style={{ opacity, cursor: 'move' }} ref={ref}>
      <StyledPaper square>
        <DragItem
          title={props.title}
          onDeleteDrag={props.handleDeleteAction}
          cost={props.cost}
          timings={props.timings}
          isActionDrag={props.isActionDrag}
          handleEdit={props.handleOpenWithEdit}
        />
      </StyledPaper>
    </Grid>
  );
};

const StyledPaper = styled(props => <Paper {...props} />)`
  padding: 12px;
  &.MuiPaper-root {
    background-color: #ffffff;
  }
`;

export default AssessmentEditDragItem;
